<div>
  <div class="max-w-lg mx-auto mt-6 sm:mt-14 mb-20 p-6 bg-white rounded-lg sm:shadow-md sm:shadow-orange-800">
    <div class="text-center mb-10">
      <h1 class="text-3xl font-medium title-font text-center mb-8">Gratis Probetraining</h1>
      <h2 class="text-base text-orange-800 leading-relaxed mx-auto">
        Melde dich mit dem Formular an:
      </h2>
    </div>

    <form [formGroup]="contactFormGroup">
      <div class="grid sm:grid-cols-2 sm:gap-4">
        <div>
          <label for="first_name" class="block text-gray-600 font-medium">Vorname*</label>
          <input type="text" id="first_name" name="first_name" formControlName="firstname" maxlength="30" required
            class="form-element"
            [ngClass]="{ 'ring-2 ring-red-500': (isFirstnameInvalid && firstname.errors) }">
          <div class="h-4">
            @if (isFirstnameInvalid && firstname.errors?.['required']) {
              <div class="text-red-500 text-sm">
                Vorname ist obligatorisch
              </div>
            }
          </div>
        </div>
        <div>
          <label for="last_name" class="block text-gray-600 font-medium">Nachname*</label>
          <input type="text" id="last_name" name="last_name" formControlName="lastname" maxlength="30" required
            class="form-element"
            [ngClass]="{ 'ring-2 ring-red-500': (isLastnameInvalid && lastname.errors) }">
          <div class="h-4">
            @if (isLastnameInvalid && lastname.errors?.['required']) {
              <div class="text-red-500 text-sm">
                Nachname ist obligatorisch
              </div>
            }
          </div>
        </div>
      </div>

      <div class="grid sm:grid-cols-2 sm:gap-4">
        <div class="mb-4">
          <label for="zip" class="block text-gray-600 font-medium">PLZ</label>
          <input type="text" id="zip" name="zip" formControlName="zip" maxlength="4"
            class="form-element">
        </div>
        <div class="mb-4">
          <label for="address" class="block text-gray-600 font-medium">Ort</label>
          <input type="text" id="address" name="address" formControlName="address" maxlength="100" class="form-element">
        </div>
      </div>

      <!-- Telephone -->
      <div>
        <label for="phone" class="block text-gray-600 font-medium">Telefonnummer*</label>
        <input type="tel" id="phone" name="phone" formControlName="phone" maxlength="12" required class="form-element"
          [ngClass]="{ 'ring-2 ring-red-500': (isPhoneInvalid && phone.errors) }">
        <div class="h-4">
          @if (isPhoneInvalid && phone.errors?.['required']) {
            <div class="text-red-500 text-sm">
              Telefonnummer ist obligatorisch
            </div>
          }
        </div>
      </div>

      <!-- Email -->
      <div>
        <label for="email" class="block text-gray-600 font-medium btn-primary">E-Mail*</label>
        <input type="email" id="email" name="email" formControlName="email" maxlength="60" required
          class="form-element"
          [ngClass]="{ 'ring-2 ring-red-500': (isEmailInvalid && email.errors) }">
        <div class="h-4">
          @if (isEmailInvalid && email.errors?.['required']) {
            <div class="text-red-500 text-sm">
              E-Mail ist obligatorisch
            </div>
          }
        </div>
      </div>

      <div class="grid sm:grid-cols-3 sm:gap-4">
        <div class="mb-4">
          <label class="block text-gray-600 font-medium">Interesse</label>
          <select formControlName="interest" class="form-element">
            <option value="bjj">Brazilian Jiu-Jitsu</option>
            <option value="thai">Boxen / Kickboxen / Thaiboxen</option>
            <option value="gym">Gym / Workout</option>
            <option value="all">Alles</option>
          </select>
        </div>
        <div class="mb-4">
          <label class="block text-gray-600 font-medium">Gruppe</label>
          <select formControlName="group" class="form-element">
            <option value="erwachsene">Erwachsene</option>
            <option value="kind">Kind</option>
          </select>
        </div>
        <div class="mb-4">
          <label class="block text-gray-600 font-medium">Niveau</label>
          <select formControlName="level" class="form-element">
            <option value="beginner">Beginner</option>
            <option value="intermediate">Intermediate</option>
            <option value="expert">Expert</option>
          </select>
        </div>

      </div>

      <!-- Free Message Text Area -->
      <div class="mb-4">
        <label for="message" class="block text-gray-600 font-medium">Bemerkungen</label>
        <textarea id="message" name="message" rows="4" formControlName="message" maxlength="5000"
        class="form-element"></textarea>
      </div>

      <!-- Submit Button -->
      <div class="mt-6">
        @if (!saving) {
          <button class="text-white border-0 py-2 px-8 focus:outline-none rounded text-lg bg-orange-800 hover:bg-amber-700"
            (click)="send()">
            Absenden
          </button>
        }
        @if (saving) {
          <button class="bg-orange-200 border-0 py-2 px-16 focus:outline-none rounded text-lg"
            [disabled]="true">
            <div role="status">
              <svg aria-hidden="true" class="inline w-6 h-6 text-gray-100 animate-spin dark:text-gray-500 fill-orange-800"
                viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"/>
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"/>
              </svg>
              <span class="sr-only">Loading...</span>
            </div>
          </button>
        }
      </div>
    </form>
  </div>
</div>
